<span
  class="ui-owner-chip"
  [class.ui-owner-chip-janek]="tone() === 'janek'"
  [class.ui-owner-chip-zosia]="tone() === 'zosia'"
  [class.ui-owner-chip-pawel]="tone() === 'pawel'"
  [class.ui-owner-chip-dom]="tone() === 'dom'"
  [class.ui-owner-chip-neutral]="tone() === 'neutral'"
>
  <span class="ui-owner-chip-dot" aria-hidden="true"></span>
  {{ label() }}
</span>
